import React from "react"
import {
  Button as MUIButton,
  ButtonProps as MUIButtonProps,
} from "@mui/material"
import { MUIMappedButton } from "./mantine/Button.mantine"

export type BaseButtonProps =
  | ({ new: true } & MUIButtonProps)
  | ({ new?: false } & MUIButtonProps)

export const BaseButton = React.forwardRef<HTMLButtonElement, BaseButtonProps>(
  (props, ref) =>
    props.new ? (
      <MUIMappedButton {...props} ref={ref} />
    ) : (
      <MUIButton {...props} ref={ref} />
    ),
)

BaseButton.displayName = "BaseButton"

export default BaseButton
